/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TriggerArgs_TimerCallback } from "../../trigger_args";

export const protobufPackage = "complimentary_actions";

export interface SimEventBatteryActionArgs {
  trigger:
    | TriggerArgs_TimerCallback
    | undefined;
  /**
   * The ratio of battery (in the range [0, 1]) that will be adopted by the sim when this Action is
   * processed. E.g. battery_ratio = 0.25 will cause the sim to set its current battery level to
   * 25%.
   */
  batteryRatio: number;
}

function createBaseSimEventBatteryActionArgs(): SimEventBatteryActionArgs {
  return { trigger: undefined, batteryRatio: 0 };
}

export const SimEventBatteryActionArgs = {
  encode(message: SimEventBatteryActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.trigger !== undefined) {
      TriggerArgs_TimerCallback.encode(message.trigger, writer.uint32(10).fork()).ldelim();
    }
    if (message.batteryRatio !== 0) {
      writer.uint32(21).float(message.batteryRatio);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SimEventBatteryActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimEventBatteryActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.trigger = TriggerArgs_TimerCallback.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.batteryRatio = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimEventBatteryActionArgs {
    return {
      trigger: isSet(object.trigger) ? TriggerArgs_TimerCallback.fromJSON(object.trigger) : undefined,
      batteryRatio: isSet(object.batteryRatio) ? globalThis.Number(object.batteryRatio) : 0,
    };
  },

  toJSON(message: SimEventBatteryActionArgs): unknown {
    const obj: any = {};
    if (message.trigger !== undefined) {
      obj.trigger = TriggerArgs_TimerCallback.toJSON(message.trigger);
    }
    if (message.batteryRatio !== 0) {
      obj.batteryRatio = message.batteryRatio;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimEventBatteryActionArgs>, I>>(base?: I): SimEventBatteryActionArgs {
    return SimEventBatteryActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimEventBatteryActionArgs>, I>>(object: I): SimEventBatteryActionArgs {
    const message = createBaseSimEventBatteryActionArgs();
    message.trigger = (object.trigger !== undefined && object.trigger !== null)
      ? TriggerArgs_TimerCallback.fromPartial(object.trigger)
      : undefined;
    message.batteryRatio = object.batteryRatio ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
